import React from "react";
import { Box, Button } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Delete } from "@mui/icons-material";
import LoadingButton from "../../../../components/Buttons/LoadingButton";

const PolicyVersionDetailsButtonsFooter = ({
  releaseFirst,
  releasePending,
  deployDisabled,
  disabled,
  releaseNumber,
  isReleaseOwner,
  onDeployClick,
  onDeleteReleaseClick
}) => {
  const { t } = useTranslation();

  return (
    <Box
      flex={1}
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Box display="flex" justifyContent="flex-start">
        {!releaseFirst && releasePending && isReleaseOwner && (
          <LoadingButton
            pending={disabled}
            startIcon={<Delete />}
            onClick={() => onDeleteReleaseClick()}
            color="primary"
            size="large"
            disabled={disabled}
            data-qa="policy-version-delete-pending-release-btn"
          >
            {t("courseVersion.details.deleteBtn")}
          </LoadingButton>
        )}
      </Box>
      {releasePending && (
        <Box justifyContent="flex-end">
          <Button
            color="primary"
            variant="contained"
            onClick={() => onDeployClick()}
            data-qa="policy-version-deploy-btn"
            disabled={disabled || deployDisabled}
          >
            {t("courseVersion.details.policyDeployBtn", {
              releaseNum: releaseNumber
            })}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default PolicyVersionDetailsButtonsFooter;

PolicyVersionDetailsButtonsFooter.propTypes = {
  onCreateReleaseClick: PropTypes.func,
  onDeleteReleaseClick: PropTypes.func,
  onPreviewClick: PropTypes.func,
  isReleaseOwner: PropTypes.bool,
  disabled: PropTypes.bool,
  releasePending: PropTypes.bool,
  releaseFirst: PropTypes.bool
};
